import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-facebook",
  "use": "icon-facebook-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-facebook\">\n    <g fill=\"none\" fill-rule=\"evenodd\">\n        <path fill=\"none\" d=\"M0 0h24v24H0z\" />\n        <path d=\"M17.25 9H13.5V6c0-.828.672-.75 1.5-.75h1.5V1.5h-3A4.5 4.5 0 0 0 9 6v3H6v3.75h3V21h4.5v-8.25h2.25L17.25 9z\" fill=\"#000018\" fill-rule=\"nonzero\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol